import React, { useState, useEffect } from "react";
import { Toolbar, Box } from "@mui/material";
import Appbar from "./components/NavBar";
import Dashboard from "./components/Dashboard";
import "../src/components/style.css";
import UserInfoModal from "./components/UserInfoModal";
import { useProfile } from "./hooks/useProfile";
import { useQueryClient } from "@tanstack/react-query";

const getInitials = (fullName) => {
  if (!fullName) return "G"; // Guest
  const parts = fullName.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
  return (first + last).toUpperCase();
};

const Home = () => {
  const queryClient = useQueryClient();
  const [isUserInfoModalOpen, setUserInfoModalOpen] = useState(false);
  const { data: userProfile, isLoading: userInfoLoading } = useProfile();

  useEffect(() => {
    return () => queryClient.clear();
  }, [queryClient]);

  const initials = getInitials(userProfile?.fullName);

  return (
    <Box className="app-main" sx={{ display: "flex", flexDirection: "column" }}>
      <Appbar
        appName="Product Validation - Offer Template | Zuora | SFDC"
        userName={initials}
        isUserInfoLoading={userInfoLoading}
        setUserInfoModalOpen={setUserInfoModalOpen}
      />

      <div className="dashboard-top-bar" />

      <div className="page-content">
        <Dashboard />
      </div>

      <UserInfoModal
        isOpen={isUserInfoModalOpen}
        data={userProfile || {}} 
        onClose={() => setUserInfoModalOpen(false)}
      />
    </Box>
  );
};

export default Home;
